import { useState } from "react";
import { faqs } from "@/mocks/dramas";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20" aria-labelledby="faq-title">
      <div className="mx-auto grid max-w-page grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="text-xs font-label tracking-[0.3em] text-primary-400">常见问题</span>
          <h2 id="faq-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于选题、榜单与评分的疑问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            第一次来黑料剧场？这几个问题能帮你快速了解我们怎么选剧、怎么排序、怎么给出评分。
          </p>
          <div className="mt-6 rounded-lg border border-accent-500/30 bg-accent-100/20 p-5">
            <p className="flex items-start gap-3 text-sm leading-relaxed text-foreground-800">
              <i className="ri-lightbulb-line mt-0.5 text-lg text-accent-400" aria-hidden="true"></i>
              没找到答案？可以在「关于我们」页面给我们留言，我们会在两个工作日内回复。
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-100/60">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer transition-colors hover:bg-background-200/40"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-primary-400 transition-transform ${
                        open ? "rotate-45" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}